import { useDocumentsSection } from "@/components/Sections/Documents";
import { IS_SERVER } from "@/constants";
export const useDocuments = () => {
    const documents = useDocumentsSection();
    if (!documents)
        return null;
    const { files, display } = documents;
    if (!display)
        return null;
    const onPress = (url) => async () => {
        var _a;
        if (IS_SERVER)
            return;
        (_a = window.open(url, "_blank")) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return { onPress, files, display };
};
